import { defineComponent as _defineComponent } from 'vue';
import { onMounted, ref } from "vue";
import { GalaxyApi } from "@/api";
import { rethrowSimple } from "@/utils/simple-error";
import PublishedItem from "@/components/Common/PublishedItem.vue";
import HistoryView from "@/components/History/HistoryView.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'HistoryPublished',
    props: {
        id: null
    },
    setup(__props) {
        const props = __props;
        const history = ref();
        onMounted(async () => {
            const { data, error } = await GalaxyApi().GET("/api/histories/{history_id}", {
                params: {
                    path: { history_id: props.id },
                },
            });
            if (error) {
                rethrowSimple(error);
                return;
            }
            // The default view is the detailed view
            history.value = data;
        });
        return { __sfc: true, props, history, PublishedItem, HistoryView };
    }
});
